import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { NavLink, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {  getHasNextPage, getNextPostsAPI, getPostsPageAPI } from '../../RTK/Slice/PageSlice'
import ListPostsNormal from '../Utils/ListPostNormal'

const AllPostPageComponent = () => {

// For Translate Content
const {t} = useTranslation() ;

  // For Search for post 
  const [search , setSearch] = useState('') ;

  // For Handle Search for posts
  const searchPostHandler = (e)=>{
    setSearch(e.target.value) ;
  }

// For Access User Token
const activeToken = useSelector(getActiveToken) ;

// For Access Page Posts 
const {pagePosts , statusOfPagePost} = useSelector(state => state.PageSlice) ;

// For Get Token
const token = useSelector(getToken) ;

// For Disptach Action
const disptach = useDispatch() ; 

// For Access has next
const hasNext = useSelector(getHasNextPage) ; 

const hasNextHandler = ()=>{
  if(hasNext){
    disptach(getNextPostsAPI({token , userToken :activeToken , pageId , hasNext}))
  }
}

// For Get Parameters
const {pageId , pageToken} = useParams() ; 

useEffect(()=>{
  if(activeToken !== null && pageId && pageToken){
    disptach(getPostsPageAPI({token , pageId , pageToken , activeToken}));
  }else{
    toast.error("Please Choose User Token Reload Again")
  }
} , [disptach , activeToken , pageId , pageToken ,token])


  return (
    <div className='all-post-page'>
        <div className='group-btn'>
          <NavLink to={`/messages/${pageId}/${pageToken}`} className="message-btn">
            {t('retargetingButton')}
          </NavLink>
          {/*<NavLink to={`/messages/${pageId}/${pageToken}/messengers`} className="message-btn">
            Messengers IDs
          </NavLink>*/}
        </div>
        
        <ListPostsNormal hasNextHandler={hasNextHandler} hasNext={hasNext} posts={pagePosts} status={statusOfPagePost} />
    </div>
  )
}

export default AllPostPageComponent
